import axios from 'axios';
import React, { useEffect } from 'react';
import * as THREE from "three";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import SideStyle from '../style/sideStyle';
import Control from '../store/control';
import Param from '../store/param';
// import { Start, Check, GetSTL, GetLog } from "../fileIO/post";
import { Vpoints2Array } from "../shape/Adapter";
import { GetTrim3D } from '../shape/Trim';
import { AddIcon } from './formUtil';
// import { POLLING_INTERVAL1, POLLING_INTERVAL10 } from '../store/global';


const FormTrim = () => {
  const style          = SideStyle();
  const trim           = Param.Get("trim");
  // const modify         = Param.Get("modify");
  const setParam       = Param.Get("setParam");
  const setControl     = Control.Get("setControl");
  // const meshSocketF11  = Control.Get("meshSocketF11");
  const meshSocketCompress = Control.Get("meshSocketCompress");
  const meshSocketModify = Control.Get("meshSocketModify");
  const meshSocketModifyVtk = Control.Get("meshSocketModifyVtk");
  const SetCameraOut    = Control.Get("SetCameraOut");

  useEffect(() => {
    SetCameraOut()
    setParam(s => {s.instructionText = "Edit the projectoin curve, and push [Applying to 3D curve]."});
  }, []);

  const onTrim = () => {

    if (process.env.REACT_APP_CALC_MODE == 0) {
      console.log("onTrim local");
      setParam(s => {s.trim.step = 2});

    } else if (process.env.REACT_APP_CALC_MODE == 1) {
      console.log("onTrim server");
      const trimPoints = Vpoints2Array(trim.vpt3D)

      /*
      const trimPoints =  [[-4.7, 27, 59],
                          [4.7, 30, 58],
                          [33, 40, 41],
                          [46, 50, 20],
                          [48, 40, -1],
                          [43, 15, -22],
                          [17, 0, -52],
                          [-5, -6, -56],
                          [-29, 0, -52],
                          [-57, 15, -22],
                          [-61, 40, -1],
                          [-54, 50, 20],
                          [-40, 40, 41],
                          [-18, 30, 58]]
      */
    
      // axios settings
      const url  = process.env.REACT_APP_BACKEND_SERVER + "/api/trim";
      const data = {
        'socketVertices': meshSocketModifyVtk.vertices,
        'socketFaces': meshSocketModifyVtk.faces,
        'smooth': Number(trim.smooth),
        'nTrimPointsMod': Number(trim.nTrimPointsMod),
        'trimPoints': trimPoints,
      };
      const header = {
        headers: {
          'Content-Type': 'application/json',
        }
      };

      axios.post(url, data, header)
      //axios.get(url)
      .then(res => {
        console.log('get data from server to client');

        // socket mesh surface
        if (true) {
          const socketVertices = res.data['socketVertices'];
          const socketFaces = res.data['socketFaces'];

          var vertices = [];
          var faces = [];
          var face = [];
          var nFace = [];
          var temp = [];

          // convert to numpy array to three array
          for (var i = 0; i < socketVertices.length; i++) {
            var p = new THREE.Vector3(...socketVertices[i]);
            vertices.push(p);
          }

          console.log(socketFaces.length)
          // convert to numpy array to three array
          for (var i = 0; i < socketFaces.length; i++) {
            nFace = socketFaces[i];
            face = socketFaces.slice(i+1, i+nFace+1);

            if (nFace==3) {
              //faces.push(new THREE.Face3(...face)); // this is for geometry format, but departed and not working well
              faces.push(...face) // this is for buffergeometry
            } else if (nFace==4) { // devide quad mesh into two triangle mesh
              temp = [face[0], face[1], face[2]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // this is for buffergeometry
              temp = [face[0], face[2], face[3]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // // this is for buffergeometry
            }
            i += nFace;
          }
          
          setParam(s => {s.trim.step = 2});

          var temp = {
            vertices: res.data['socketVertices'],
            faces: res.data['socketFaces'],
          };
          console.log(temp)
          setControl(s => {s.meshSocketTrimVtk = temp});

          temp = {
            vertices: vertices,
            faces: faces,
          };
          console.log(temp)
          setControl(s => {s.meshSocketTrim = temp});
        }
      })
      .catch(err => {
        console.log('error');
      });
    }
  }


  const submitF15 = () => {
    console.log('submit15');
    // SetControl(s => {s.showCircle = true});
    
    // const mes = {
    //   //trim用パラメータ(f14と同じ)
    //   "filepath": modify.is_skip ? "f10_output.vtp" : "f11_output.vtp",
    //   "trimming_points": Vpoints2Array(trim.vpt3D),
    //   "num_mod_points": 400,
    //   "smooth_post_trim": trim.smooth,
    //   "trimmer_width": 0.0,
    //   "debug_out":0,
    //   //bend用パラメータ
    //   "force_trim": true,
    //   "curve_width": Number(trim.curve_width),
    //   "curve_angle": Number(trim.curve_angle),
    //   "curve_r": Number(trim.curve_r),
    //   "curve_smooth": Number(trim.curve_smooth),
    //   "curve_range": Number(trim.curve_range),
    //   "clean_pre_deform": 2,
    //   "clean_pre_deform_abs_tol_r": 0.001,
    //   "smooth_pre_deform": 0,
    //   "remesh_pre_deform": true, 
    //   "remesh_pre_deform_hmin_ratio": 0.1, 
    //   "remesh_post_deform": false, 
    //   "remesh_post_deform_hmin_ratio": 0.1, 
    //   "skip_deform": false, 
    //   "deform_root_extraction_tol": 0.02, 
    // };
    // Start( mes, 'f15', CallStart, CallError); 
  };

  // var CallStart = function(funcno, pid){
  //   if(funcno == 'f14'){
  //     setTimeout(Polling, POLLING_INTERVAL1, funcno, pid);
  //   }
  //   else if(funcno == 'f15'){
  //     setTimeout(Polling, POLLING_INTERVAL10, funcno, pid);
  //   }
  // };
  // var CallCheck = function(funcno, pid, status){
  //   if(Number(status) == 1){
  //     if(funcno == 'f14'){
  //       setTimeout(Polling, POLLING_INTERVAL1, funcno, pid);
  //     }
  //     else if(funcno == 'f15'){
  //       setTimeout(Polling, POLLING_INTERVAL10, funcno, pid);
  //     }
  //   }else{
  //     GetLog(funcno);
  //     GetSTL(funcno, CallEnd, CallError);
  //   }
  // };
  // var CallEnd = function(funcno, mesh){
  //   if(funcno == 'f14'){
  //     SetParam(s => {s.trim.step = 2});
  //   }
  //   else if(funcno == 'f15'){
  //     SetParam(s => {s.trim.step = 3});
  //   }
  //   SetControl(s => {s.meshSocketF14 = mesh, s.showCircle = false});
  // };
  // var CallError = function(){
  //   SetControl(s => {s.showCircle = false});
  // };
  // var Polling = function(funcno, pid){
  //   Check(funcno, pid, CallCheck, CallError);
  // };

  const handleValue = (e) => {
    setParam(s => {s.trim[e.target.name] = Number(e.target.value)});
  };

  const to3D = () => {
    //change Vector3(0, x, y) --> Vector2(x, y)
    var vpt = [];
    console.log("to3d")
    trim.vpt2D.forEach( pt => {
      vpt.push(new THREE.Vector2(pt.y, pt.z));
    });

    // for marking
    var meshSocket = null;
    // server calculation
    if ( meshSocketCompress && process.env.REACT_APP_CALC_MODE == 0) {
      meshSocket = meshSocketCompress.clone();
      meshSocket.geometry = meshSocketCompress.geometry.clone(); // for deepcopy
    } else if ( meshSocketModify && process.env.REACT_APP_CALC_MODE == 1) { 
      const geometry = new THREE.BufferGeometry();
      const material = new THREE.MeshLambertMaterial();
      geometry.setFromPoints(meshSocketModify.vertices);
      geometry.setIndex(meshSocketModify.faces)
      geometry.rotateX(-Math.PI / 2,0,0)
      meshSocket = new THREE.Mesh(geometry, material);
      //meshSocket.rotation.x = -Math.PI / 2,0,0
    }

    const vpt3D = GetTrim3D(meshSocket, vpt);

    setParam(s => {s.trim.step = 1, s.trim.vpt3D = vpt3D});
  }
  const to2D = () => {
    setParam(s => {s.trim.step = 0, s.trim.mode = 0, s.trim.vpt3D = null});
  };
  const onClear = () => {
    // SetControl(s => {s.meshSocketF14 = null});
    setControl(s => {s.meshSocketTrim = null});
    setControl(s => {s.meshSocketTrimVtk = null});
    setParam(s => {s.trim.step = 1});
  };
  const onMove = () => {
    setParam(s => {s.trim.mode = 0});
  };
  const onReset = () => {
    setParam(s => {s.trim.mode = 1});
  };
  function getActive(val){
    return (trim.mode == val) 
      ? `${style.button} ${style.buttonSelected}`
      : style.button;
  }
  function equalTo(step){
    return (trim.step == step) ? false : true;
  }
  function moreThan(step){
    return (trim.step >= step) ? false : true;
  }
  useEffect(() => {
    setControl(s => {s.flgLegClickable = false, s.flgSocketClickable = false});
  });


  return (
    <div className={style.outside}>
      <Grid container spacing={1} direction='column' justifyContent ='flex-start' alignItems='center'>

        {/* Trimming */}
        <Grid item xs={12} className={style.subcategory}>Trimming</Grid>

        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={6}>
            <Button className={getActive(0)} onClick={onMove} size="small" >Move 2D Point</Button>
          </Grid>
          <Grid item xs={6}>
            <Button className={getActive(1)} onClick={onReset} size="small" >Reset 2D Point</Button>
          </Grid>
        </Grid>
 
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={6}>
            <Button className={equalTo(0) ? style.buttonDisable : style.button} onClick={to3D} disabled={equalTo(0)} size="small" >To 3D curve</Button>
          </Grid>
          <Grid item xs={6}>
            <Button className={moreThan(1) ? style.buttonDisable : style.button} onClick={to2D} disabled={moreThan(1)} size="small" >Rest & To 2D curve</Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={1} alignItems='center'>
        <TextField
          disabled={true}
          id="filled-number"
          name='smooth'
          label="Smooth(Disabled)"
          type="number"
          defaultValue={trim.smooth}
          fullWidth
          onChange={handleValue}
          InputProps={{
            endAdornment: <AddIcon unit="" helptext="Smooth"/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:0, 
            max:10,
            step:1
          }}
        />
      </Grid>

      <Grid container spacing={1} direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={6}>
            <Button className={equalTo(1) ? style.buttonDisable : style.button} onClick={onTrim} disabled={equalTo(1)} size="small" >Trimming</Button>
          </Grid>
          <Grid item xs={6}>
            <Button className={moreThan(2) ? style.buttonDisable : style.button} onClick={onClear} disabled={moreThan(2)} size="small" >Clear Socket</Button>
          </Grid>
        </Grid>
      </Grid>

      {/* Bending*/}
      {/* <Grid container spacing={1} direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Bending</Grid>
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='curveWidth'
            label='Width'
            type='number'
            defaultValue={trim.curveWidth}
            fullWidth
            onChange={handleValue}
            InputProps={{
              endAdornment: <AddIcon unit='mm' helptext='Width of bending operation'/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:0, 
              max:50,
              step:1
            }}
          />

          <TextField
            id="filled-number"
            name='curveAngle'
            label="Angle"
            type="number"
            defaultValue={trim.curveAngle}
            fullWidth
            onChange={handleValue}
            InputProps={{
              endAdornment: <AddIcon unit="°" helptext="Angle of bending curve"/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:0, 
              max:180,
              step:1
            }}
          />

          <TextField
            id="filled-number"
            name='curveR'
            label="Radius"
            type="number"
            defaultValue={trim.curveR}
            fullWidth
            onChange={handleValue}
            InputProps={{
              endAdornment: <AddIcon unit="°" helptext="Radius of bending curve"/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:0, 
              max:10,
              step:1
            }}
          />


          <TextField
            id="filled-number"
            name='curveRange'
            label="Range"
            type="number"
            defaultValue={trim.curveRange}
            fullWidth
            onChange={handleValue}
            InputProps={{
              endAdornment: <AddIcon unit="°" helptext="Range of bending curve"/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:0, 
              max:100,
              step:1
            }}
          />
        </Grid>
        
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={12}>
          <Button className={style.button} onClick={submitF15} disabled={moreThan(1)} size="small" >Bend</Button>
          </Grid>
        </Grid>
      </Grid> */}
    </div>
  );
}
export default FormTrim;
